import { requestEnvelope } from './client'
import { eventAggregateSchema, eventSchema, paginated, type Event, type EventAggregate } from './schemas'
import type { EventFilter } from '../lib/query-keys'

export async function listEvents(f: EventFilter) {
  const params = new URLSearchParams({
    status: f.status,
    page: String(f.page ?? 1),
    pageSize: String(f.pageSize ?? 20),
  })
  if (f.type) params.set('type', f.type)
  const data = await requestEnvelope(`/events?${params.toString()}`, paginated(eventSchema))
  return data
}

export async function getEventAggregate(id: string): Promise<EventAggregate> {
  return requestEnvelope(`/events/${encodeURIComponent(id)}`, eventAggregateSchema)
}

export type { Event }
